import { forwardRef } from "react";
import { APP_CONFIG } from "@/config/app.config";
import { cn } from "@/lib/utils";

export const PageContent = forwardRef<
  HTMLDivElement,
  {
    children: React.ReactNode;
    className?: string;
    hideFooter?: boolean;
  }
>(function PageContent({ children, className, hideFooter = false }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "flex min-h-0 flex-1 flex-col overflow-y-auto p-3 mt-2 md:p-8 md:py-4 md:mt-4 mb-0 space-y-8",
        className
      )}
    >
      {children}

      {!hideFooter && (
        <footer className="mt-10 flex shrink-0 justify-center border-t border-white/10 pt-8 pb-4 font-inter">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-white/70">
            <a
              href={APP_CONFIG.WEBSITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-200"
            >
              © 2025 HeyBodhi
            </a>
            <a
              href={APP_CONFIG.PRIVACY_POLICY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-200"
            >
              Privacy Policy
            </a>
          </div>
        </footer>
      )}
    </div>
  );
});
